import { createFileRoute } from "@tanstack/react-router";
import WhatToExpectFromYourConsultation from "@/pages/WhatToExpectFromYourConsultation";
export const Route = createFileRoute("/what-to-expect-from-your-consultation")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "What To Expect From Your Consultation | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "What to expect at your depression treatment consultation at Neuro Wellness TMS in Coral Springs, FL. Questions, timeline, and next steps Free consultation.",
        },
        {
          property: "og:title",
          content: "What To Expect From Your Consultation | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "What to expect at your depression treatment consultation at Neuro Wellness TMS in Coral Springs, FL. Questions, timeline, and next steps Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/what-to-expect-from-your-consultation",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/what-to-expect-from-your-consultation",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WhatToExpectFromYourConsultation />;
}
